import { AppointmentQuestionnaire } from "@/features/appointments/AppointmentQuestionnaire";
import { useProjectQuestionnaire } from "@/features/project/useProjectQuestionnaire";
import styled from "@emotion/styled";
import { type QuestionObject } from "@repo/api";
import { Button, LightMode, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet } from "@repo/ui";
import { hasItems, trackAnalytics } from "@repo/utils";
import { useState } from "react";

const LinkButton = styled.div`
  button {
    text-decoration: underline;
  }
`;

export const CompactAppointmentQuestionnaire = ({
  opportunityId,
  additionalInformation,
}: {
  opportunityId?: number;
  additionalInformation?: QuestionObject[];
}) => {
  const [isQuestionnaireOpen, setIsQuestionnaireOpen] = useState(false);
  const { bokaQuestionnaire } = useProjectQuestionnaire(opportunityId);

  const hasQuestions = hasItems(additionalInformation);
  const totalQuestions = additionalInformation?.length ?? 0;
  const totalAnswers =
    additionalInformation?.filter((q) => hasItems(q.answer?.answer)).length ??
    0;
  const allAnswered = hasQuestions && totalAnswers === totalQuestions;

  const description = hasQuestions
    ? `${totalAnswers}/${totalQuestions}`
    : t("prompt.no_questionnaire");

  return (
    <>
      {hasQuestions && allAnswered ? (
        <LinkButton>
          <Button
            type="plain"
            size="small"
            text={`${t("label.need_analysis")}: ${description}`}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();
              setIsQuestionnaireOpen(true);
              trackAnalytics("open_questionnaire");
            }}
          />
        </LinkButton>
      ) : (
        <Text textStyle="Body.S" color={LightMode.colourTextAndIcon3}>
          {`${t("label.need_analysis")}: ${description}`}
        </Text>
      )}
      {isQuestionnaireOpen && opportunityId && (
        <ModalSheet
          title={t("label.need_analysis")}
          visible={isQuestionnaireOpen}
          onClose={() => setIsQuestionnaireOpen(false)}
        >
          <AppointmentQuestionnaire {...bokaQuestionnaire} />
        </ModalSheet>
      )}
    </>
  );
};
